import _ from 'lodash'

import { SelectOption } from '../Select'

export type props = {
  items: SelectOption[]
  numberOfColumns?: number
  onChange?: (countryCode: string) => void
  selectedOption?: SelectOption
}

const MulticolumnList = ({ items, onChange, numberOfColumns, selectedOption }: props) => {
  const columns = numberOfColumns ?? 1
  const length = items.length
  const rows = Math.ceil(length / columns)
  return (
    <>
      {_.map(_.range(columns), i => {
        const startIndex = i * rows
        const endIndex = startIndex + rows
        const countryData = items?.slice(startIndex, endIndex)
        return (
          <ul key={i}>
            {_.map(countryData, item => {
              const selectedOptionClass = selectedOption?.value === item.value ? 'selectedOption' : undefined
              return (
                <li
                  key={item.value}
                  onClick={() => (onChange ? onChange(item.value) : undefined)}
                  className={selectedOptionClass}
                >
                  <span>{item.label}</span>
                </li>
              )
            })}
          </ul>
        )
      })}
    </>
  )
}
export default MulticolumnList
